import React, { useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Grid, Switch, Typography } from "@mui/material";
import { AppBarComponent } from "../Components/AppBar";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { deleteTableDots, instance } from "../Components/config";
import { useLocation } from "react-router-dom";
import { LoaderBox } from "../Components/LoaderBox";

function RolAsignar({ rol }) {
  const { state } = useLocation();
  const { id, nombre } = state;
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
  });
  deleteTableDots(3);
  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "nombre", //access nested data with dot notation
      header: "Nombre(s)",
    },
    {
      accessorKey: "apellido",
      header: "Apellido(s)",
    },
    {
      accessorKey: "correo",
      header: "Correo electrónico",
    },
    {
      accessorKey: "estado",
      header: "",
    },
    {
      accessorFn: (row) => `${row.id}${row.nombre}`,
      id: "edit",
      header: "",
      size: 10,
      enableColumnFilter: false,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Button onClick={() => console.log("")}>
            <Switch
              color="success"
              checked={row.original.estado === 1}
              onChange={() => ToggleRolXUsuario(row.original.id)}
            />
          </Button>
        </Box>
      ),
    },
  ]);

  const ToggleRolXUsuario = (usuario) => {
    instance
      .patch(`/rol/toggleRolXUsuario`, {
        rol: id,
        usuario: usuario,
      })
      .then((res) => {
        populateTable();
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };

  async function populateTable() {
    try {
      const { data } = await instance.get("/rol/usuarios/" + id);
      setItems(data);
    } catch (error) {
      alert(error);
    }
  }
  if (isLoading) {
    populateTable();
    setLoading(false);
  }
  if (isLoading) {
    populateTable();
    setLoading(false);
  }

  return (
    <LoaderBox isLoading={isLoading}>
      <Typography
        component="h1"
        variant="title"
        sx={{ display: "flex", justifyContent: "center" }}
        mt={2}
      >
        Rol: {nombre}
      </Typography>
      <Grid container mt={1}>
        <Grid item xs={0} sm={3} md={2} />
        <Grid item xs={12} sm={6} md={8}>
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={items}
            enableRowActions={false}
            initialState={{
              showColumnFilters: false,
              columnVisibility: { id: false, estado: false },
              density: "compact",
            }}
            enableHiding={false}
            enableDensityToggle={false}
          />
        </Grid>
      </Grid>
    </LoaderBox>
  );
}

export { RolAsignar };
